interface ShowIfI {
  condition: boolean;
  children: JSX.Element;
  elseChildren?: JSX.Element;
}

/**
 *
 * @param props
 * @constructor
 */
function ShowIf(props: ShowIfI) {
  return <>{props.condition ? props.children : props.elseChildren}</>;
}

export default ShowIf;
